/** One card of the mocked supplies surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, SKELETON_KEYS, cardHeading } from './supplies-mock';

export function NextResupplyCard() {
  return (
    <section className="nb-card" style={{ flex: '0 0 auto' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={cardHeading}>
          Next Resupply
        </h3>
        <span
          className="nb-pill nb-status-soft"
          style={{ height: 18, fontSize: 9.5, padding: '0 6px' }}
        >
          Scheduled
        </span>
      </div>
      <div
        style={{
          padding: 14,
          background: 'var(--nb-cream)',
          borderRadius: 8,
          border: '1px solid var(--nb-border)',
          marginBottom: 10,
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            marginBottom: 4,
          }}
        >
          <span className="nb-display" style={{ fontSize: 18, color: 'var(--nb-forest)' }}>
            {EM_DASH}
          </span>
          <span className="nb-mono" style={{ fontSize: 10.5, color: 'var(--nb-subtle)' }}>
            {EM_DASH}
          </span>
        </div>
        <div style={{ fontSize: 11.5, color: 'var(--nb-muted)' }}>{EM_DASH}</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {SKELETON_KEYS.slice(0, 3).map((k) => (
          <div key={k} style={{ display: 'flex', gap: 10, fontSize: 11.5 }}>
            <span style={{ width: 80, fontWeight: 700, color: 'var(--nb-subtle)' }}>{EM_DASH}</span>
            <span style={{ flex: 1, color: 'var(--nb-muted)' }}>{EM_DASH}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
